export default "__VITE_ASSET__PDJ_PUtt__"